import type { PlatformPreset } from "./types.js";

const statusLabels: Record<string, string> = {
  active: "Активен",
  archived: "В архиве",
  draft: "Черновик",
  published: "Опубликован",
  queued: "В очереди",
  processing: "В обработке",
  completed: "Готово",
  partially_completed: "Готово частично",
  failed: "Ошибка",
  cancelled: "Отменено",
};

const categoryLabels: Record<string, string> = {
  product: "Продукция",
  article: "Статья",
  social: "Соцсети",
  banner: "Баннер",
  advertising: "Реклама",
  process: "Процесс",
  website: "Сайт",
  ecommerce: "Интернет-магазин",
  custom: "Пользовательская",
};

export function statusLabel(value: string) {
  return statusLabels[value] ?? value;
}

export function categoryLabel(value: string) {
  return categoryLabels[value] ?? value;
}

export function StatusBadge({ value }: { value: string }) {
  return (
    <span className={`status status-${value}`}>
      <i aria-hidden="true" />
      {statusLabel(value)}
    </span>
  );
}

export function formatDate(value: string, withTime = false) {
  return new Intl.DateTimeFormat("ru-RU", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    ...(withTime ? { hour: "2-digit", minute: "2-digit" } : {}),
  }).format(new Date(value));
}

export function aspectRatio(
  platform: Pick<PlatformPreset, "width" | "height" | "aspectRatio">,
) {
  const supplied = platform.aspectRatio?.trim();
  return supplied && supplied !== "undefined"
    ? supplied
    : ratio(platform.width, platform.height);
}

export function ratio(width: number, height: number) {
  const divisor = gcd(Math.max(1, width), Math.max(1, height));
  return `${Math.max(1, width) / divisor}:${Math.max(1, height) / divisor}`;
}

export function safeAreaLabel(preset: PlatformPreset) {
  const values = Object.values(preset.safeArea);
  if (values.every((value) => value === 0)) return "Нет";
  if (values.every((value) => value === values[0])) {
    return `${values[0]}% со всех сторон`;
  }
  return `${preset.safeArea.top}/${preset.safeArea.right}/${preset.safeArea.bottom}/${preset.safeArea.left}%`;
}

function gcd(a: number, b: number): number {
  return b ? gcd(b, a % b) : a || 1;
}
